import type {
  Addition,
  AdditionGroup,
  CartLine,
  Category,
  MenuItem,
} from "./types";

export function similarMenuItems(
  items: MenuItem[],
  current: MenuItem,
): MenuItem[] {
  return items.filter(
    (item) => item.categoryId === current.categoryId && item.id !== current.id,
  );
}

export function menuItemDisplayPrice(item: MenuItem): number {
  return item.type === "variable" && item.variations.length
    ? Math.min(...item.variations.map((variation) => variation.price))
    : item.price;
}

export function menuItemDisplayPricing(item: MenuItem): {
  price: number;
  originalPrice: number | null;
} {
  const cheapest =
    item.type === "variable" && item.variations.length
      ? item.variations.reduce((best, candidate) =>
          candidate.price < best.price ? candidate : best,
        )
      : item;
  return {
    price: cheapest.price,
    originalPrice: cheapest.originalPrice ?? null,
  };
}

export function availableCheckoutSuggestions(
  items: MenuItem[],
  lines: CartLine[],
): MenuItem[] {
  const inCart = new Set(lines.map((line) => line.itemId));
  return items.filter((item) => item.onlineAvailable && !inCart.has(item.id));
}

export function activeMenuCategory(
  categories: Category[],
  selectedId: string,
): string {
  return categories.some((category) => category.id === selectedId)
    ? selectedId
    : (categories[0]?.id ?? "");
}

export function validAdditions(
  groups: AdditionGroup[],
  selected: Addition[],
): boolean {
  return groups.every((group) => {
    const count = selected.filter(
      (addition) => addition.groupId === group.id,
    ).length;
    return count >= group.minimum && count <= group.maximum;
  });
}

export function missingRequiredAdditions(
  groups: AdditionGroup[],
  selected: Addition[],
): boolean {
  return groups.some(
    (group) =>
      selected.filter((addition) => addition.groupId === group.id).length <
      group.minimum,
  );
}
